import cmsFetch from '~/helpers/cms-fetch';
import { useDataFromPromise } from '~/helpers/page-data-utils';
function testDates(startDateStr, endDateStr) {
    const now = Date.now();
    const start = new Date(startDateStr).valueOf();
    const end = new Date(endDateStr).valueOf();
    return Boolean(start && end && now >= start && now <= end);
}
let promise;
export default function useGiveToday() {
    if (promise === undefined) {
        promise = cmsFetch('give-today');
    }
    const giveData = useDataFromPromise(promise);
    return giveData ? Object.assign(Object.assign({}, giveData), { showButton: testDates(giveData.menu_start, giveData.menu_expires), showLink: testDates(giveData.start, giveData.expires) }) : {};
}
